
<template>
  <div class="card border-secondary">
    <div class="card-header">
      <p class="card-title">Itens no Carrinho</p>
    </div>
    <div class="card-body">
      <div class="d-flex p-0 mb-3 border-bottom align-items-center" v-for="(item, indice) in itensCarrinho" :key="indice">
        <div class="mr-1 icone-container">
          <b-img :src="obterIcone(item.produto.icone)" :blank="!item.produto.icone" width="25" height="25" :class="{'icone': !ehProdutoMirt(item.produto.id) }" alt="Fluid image"></b-img>
        </div>
        <div class="flex-grow-auto item-nome">
          <span class="font-weight-bold">{{item.produto.nome}}</span>
          <span class="text-muted small d-flex flex-wrap" v-if="!ehProdutoMirt(item.produto.id) && !ehProdutoIlimitado(item.produto.plano)">Pacote {{item.produto.plano.item_planos.quantidade}} {{item.produto.plano.item_planos.nome }}</span>
          <span class="text-muted small d-flex flex-wrap" v-else-if="!ehProdutoMirt(item.produto.id)">Pacote Ilimitado {{item.produto.plano.item_planos.nome }}</span>
        </div>
        <div class="flex-grow-1 font-weight-bold ml-1 text-right">{{formatarValorMonetario(item.produto.plano.valor)}}</div>
        <div class="d-flex align-items-center ">
          <button class="btn btn-link btn-md px-2" @click="diminuirQuantidade({item, indice})">-</button>
          <b-form-input class="quantidade-input p-0 form-control-sm text-center" type="number" :readonly="true" v-model="item.produto.quantidade" :min="1" :number="true"></b-form-input>
          <button class="btn btn-link btn-md px-2" @click="aumentarQuantidade({item, indice})">+</button>
        </div>
        <div class="d-flex align-items-center ml-2">
          <button class="btn btn-no-background btn-md px-2" @click="ActionRemoverItemCarrinho({item, indice})" ><i class="far fa-trash-alt"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItensCarrinho from './js/itens-carrinho'
export default ItensCarrinho
</script>

<style scoped>
  .icone-container {
    background-color: #194175;
    display: inline-flex;
    padding: 0.5rem;
  }

  .icone {
    filter: invert(1) sepia(1) saturate(5) hue-rotate(180deg);
  }

  .quantidade-input {
    width: 2.7rem;
  }

  .btn-no-background {
    background-color: transparent;
    color: #6c757d;
    border: none;
  }
  .btn-no-background:hover {
    color: #000000;
  }

</style>
